import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { MaterialControlValueAccessor } from '../core/material-cva'
import { UntypedFormControl, NgControl, ReactiveFormsModule } from '@angular/forms'
import { ErrorMessageResolver } from 'src/app/shared/modules/form/errors/error-message-resolver'
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/select'
import { NgIf } from '@angular/common'
import { MatInput } from '@angular/material/input'
import { MatIconButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { FmxErrorsComponent } from '../errors/errors.component'

@Component({
	selector: 'app-input',
	template: `
		<mat-form-field [appearance]="appearance" class="w-100">
			<mat-label *ngIf="label">{{ label }}</mat-label>
			<input
				matInput
				[type]="type"
				placeholder="{{ placeholder }}"
				[formControl]="control"
				[errorStateMatcher]="errorStateMatcher"
				[readonly]="readonly"
			/>

			<button *ngIf="icon" mat-icon-button matSuffix aria-label="Suffix btn" (click)="iconClick.emit()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>

			<mat-error>
				<fmx-errors
					[control]="externalControl"
					[resolvers]="resolvers"
					[controlLabel]="errorLabel || label || placeholder"
				></fmx-errors>
			</mat-error>
		</mat-form-field>
	`,
	styleUrls: ['./input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatFormField,
		NgIf,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		MatIconButton,
		MatSuffix,
		MatIcon,
		MatError,
		FmxErrorsComponent,
	],
})
export class InputComponent extends MaterialControlValueAccessor {
	protected readonly controlDirective: NgControl

	@Input() readonly type: 'text' | 'number' | 'password' | 'email' = 'text'
	@Input() readonly resolvers: Array<ErrorMessageResolver> = []
	@Input() readonly icon: string = ''
	@Input() readonly: boolean = false
	@Output() readonly iconClick: EventEmitter<void> = new EventEmitter<void>()
	readonly control: UntypedFormControl = new UntypedFormControl()

	constructor() {
		const controlDirective = inject<NgControl>(NgControl)

		super(controlDirective)

		this.controlDirective = controlDirective
	}
}
